export default __webpack_public_path__ + "static/media/call-me-back-white.96d44879.png";